import { connect } from 'react-redux';

import SubpageResizeEventManager from './subpage_resize_event_manager.jsx';

import {
  setShouldRenderAsMobile
} from 'zoomforth_codesbane_viewer/action_creators/viewer.js';

const mapStateToProps = ()=> {
  return {};
};

const mapDispatchToProps = (dispatch)=> {
  return {
    onShouldRenderAsMobileChange: (shouldRenderAsMobile)=> {
      dispatch(setShouldRenderAsMobile(shouldRenderAsMobile));
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SubpageResizeEventManager);
